import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

// One-field dialog behind the "+" next to Facility ID and Sampling Point ID.
// VLP does the same job with a window.prompt; this keeps it in the app's own
// styling and lets the caller report a failure without losing what was typed.
const QuickAddValueDialog = ({ open, title, label, onClose, onAdd }) => {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  // Start from an empty field each time the dialog is opened.
  useEffect(() => {
    if (open) {
      setName("");
      setSaving(false);
    }
  }, [open]);

  const handleAdd = async () => {
    if (!name.trim() || saving) return;

    setSaving(true);
    try {
      await onAdd(name);
      onClose();
    } catch (error) {
      // The caller has already reported it; stay open so the text survives.
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={label}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleAdd()}
          fullWidth
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          onClick={handleAdd}
          variant="contained"
          color="primary"
          disabled={saving || !name.trim()}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuickAddValueDialog;
